import React from 'react';
import { Layout } from 'fronton-react';
import { RootLayout } from 'common/components';
import { SpecialOffer } from 'remotes/special-offer';
import {
  ADPLATFORM_TRAINING_BREADCRYMBS,
  ADPLATFORM_TRAINING_ELEMENT_BLOCK,
  ADPLATFORM_TRAINING_PATH,
} from './adplatform-training-constants';
import {
  AdplatformTrainingFirstStepSection,
  AdplatformTrainingReelsSection,
  AdplatformTrainingWebinarSection,
} from './components';

export const AdplatformTraining = () => (
  <RootLayout
    currentPage={ADPLATFORM_TRAINING_PATH}
    customBreadcrumbs={ADPLATFORM_TRAINING_BREADCRYMBS}
    showCurrentPage>
    <Layout>
      <SpecialOffer elementBlock={ADPLATFORM_TRAINING_ELEMENT_BLOCK} />
      <AdplatformTrainingReelsSection />
      <AdplatformTrainingWebinarSection />
      <AdplatformTrainingFirstStepSection />
    </Layout>
  </RootLayout>
);
